import { ProfileAction, ProfileActionKeys } from './actions';
import { MultiAppAuthenticationInfosActionKeys, MultiAppAuthenticationInfosAction } from '../MultiAppAuthentication/actions';
import { Api } from '../../typings/api';

export enum AvatarSize {
	SMALL = 65,
	BIG = 110,
}

export interface UserAvatarState {
	// this field keeps a selected file (image is displayed via URL.createObjectURL) and prevents uploading of image from server (photoPath) after saving (to avoid image flickering)
	file: File | null;
	// this field prevents loading of file on server when position or size of avatar were updated
	isNew: boolean;
	isEdited: boolean;
	isRemoved: boolean;
	isLoaded: boolean;
	initialImage: string | null;
	config: Api.ProfilePhotoConfig;
}

export interface ProfileState extends Api.ProfileData {
	isLoading: boolean;
	userAvatar: UserAvatarState;
}

export interface ProfilePageFields {
	name: string;
	position: string;
	phone: string;
	password: string;
	confirmPassword: string;
	photoConfig?: string | null;
	crmProviders?: Api.CRMProviderData[] | null;
	emailProvider?: Api.EmailProviderData;
}

const initialState = {
	isLoading: false,
	userAvatar: {
		file: null,
		isNew: false,
		isEdited: false,
		isRemoved: false,
		isLoaded: true,
		initialImage: null,
		config: {},
	},
} as ProfileState;

export const profile = (state: ProfileState = initialState, action: ProfileAction | MultiAppAuthenticationInfosAction): ProfileState => {
	switch (action.type) {
		case ProfileActionKeys.SET_IS_LOADING:
			return {
				...state,
				isLoading: action.isLoading,
			};
		case ProfileActionKeys.SET_DATA:
			return {
				...state,
				...action.data,
				userAvatar: {
					...state.userAvatar,
					isNew: !action.data.photoPath,
					isEdited: false,
					isRemoved: false,
					isLoaded: true,
					initialImage: action.data.photoPath,
					config: action.data.photoConfig === null
						? {}
						: JSON.parse(action.data.photoConfig),
				},
			};
		case ProfileActionKeys.ADD_USER_AVATAR:
			return {
				...state,
				userAvatar: {
					...state.userAvatar,
					file: action.file,
					isNew: true,
					isEdited: true,
					isRemoved: false,
					isLoaded: false,
					config: {
						...state.userAvatar.config,
						name: action.file.name,
						x: 0,
						y: 0,
						width: AvatarSize.BIG,
						height: AvatarSize.BIG,
					},
				},
			};
		case ProfileActionKeys.UPDATE_USER_AVATAR:
			return {
				...state,
				userAvatar: {
					...state.userAvatar,
					isEdited: true,
					isLoaded: true,
					config: {
						...state.userAvatar.config,
						...action.data,
					},
				},
			};
		case ProfileActionKeys.REMOVE_USER_AVATAR:
			return {
				...state,
				photoPath: null,
				userAvatar: {
					...state.userAvatar,
					file: null,
					isNew: false,
					isEdited: true,
					isRemoved: true,
					isLoaded: true,
					config: {} as Api.ProfilePhotoConfig,
				},
			};
		case ProfileActionKeys.RESET_USER_AVATAR:
			return {
				...state,
				photoPath: state.userAvatar.initialImage,
				userAvatar: {
					...state.userAvatar,
					file: null,
					isEdited: false,
					config: state.photoConfig === null
						? {}
						: JSON.parse(state.photoConfig),
				},
			};
		case ProfileActionKeys.ENABLE_CRM_PROVIDER:
			return {
				...state,
				crmProviders: state.crmProviders.map((item) => ({
					...item,
					enabled: item.provider === action.crmProvider,
				})),
			};
		case MultiAppAuthenticationInfosActionKeys.LOGOUT:
			return initialState;
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProfilePage/reducer.ts